// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";

import "babel-polyfill";

// import axios from 'axios';
// axios.defaults.headers.common['x-requested-with'] = 'XMLHttpRequest';

// import JsonExcel from 'vue-json-excel'

// Vue.component('downloadExcel', JsonExcel)
import store from "./store/index";

// Vue.use(Vuex)
//使用英文版elementUI 组件
import locale from "element-ui/lib/locale/lang/en";
import ElementUI from "element-ui";
Vue.use(ElementUI, { locale });

import "element-ui/lib/theme-chalk/index.css";

// Vue.use(ElementUI)
import { Message, Loading, MessageBox, Notification } from "element-ui";
Vue.prototype.$message = Message;
Vue.prototype.$loading = Loading.service;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$notify = Notification;

import util from "./ask/util";
Vue.use(util);

// 全局指令
import directives from "@/utils/directive.js";
Vue.use(directives);

// 全局组件
import components from "@/components/public/index";
Vue.use(components);

import htmlToPdf from "./ask/htmlToPdf";
Vue.use(htmlToPdf);

import { VueJsonp } from "vue-jsonp";

// Vue Plugin.
Vue.use(VueJsonp);

window.eventBus = new Vue();

Vue.config.productionTip = false;

//import BaiduMap from 'vue-baidu-map'
// import { BaiduMap, BmScale, BmGeolocation } from 'vue-baidu-map'
// Vue.use(BaiduMap,BmScale, BmGeolocation, {
//   // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
//   ak: 'aSQ1x9Lp7qQYtIl3aijyVhK7xyPGlcxG'
// })

/*------引入全局通用样式------*/
import "./assets/css/com-pc.css";
import "./assets/css/frame.css"; //弹框样式
import "./assets/css/common.less";
// import './styles/index.scss'

//全局引用验证
import "../static/js/jquery-1.7.2.min.js";
import "../static/js/jquery.validationEngine";
import "../static/js/jquery.cookie.js";
import "../static/js/jquery.validationEngine-zh_CN";
import "../static/css/validationEngine.jquery.css";

/*------引入ico字体样式*/
import "../static/ico/font-awesome.css";

/*局部修改elementUI样式*/
/*!*取消按钮*!*/
/*.el-message-box__wrapper .btn-custom-cancel {float:right;margin:0 120px 0 0 !important;;}*/
/*!*确定或者删除按钮*!*/
/*.el-message-box__wrapper .el-message-box__btns button:nth-child(2){margin:0 0 0 120px !important;}*/
// import "./assets/css/tipsMessage.css"

import "./assets/css/tipsMessage.css";

//外部按照时间格式转换器
import moment from "moment";
//全局过滤器
Vue.filter("dateFmt", (input, formatString = "YYYY-MM-DD") => {
  //es5函数参数设置默认值
  //const lastFormatString = formatString || ''

  /**
   * moment(input) 把时间字符串转成时间对象
   * format(formatString)  把时间对象，按照指定格式，格式化成符合条件的字符串
   */
  return moment(input).format(formatString);
});

/*==============根据域名判断所调接口================*/
// Vue.prototype.$api01 = By56Api.api01
// Vue.prototype.$api02 = By56Api.api02
// Vue.prototype.$api03 = By56Api.api03
// Vue.prototype.$api04 = By56Api.api04
// Vue.prototype.$apiFileCloud = By56Api.apiFileCloud
// Vue.prototype.$apiFileCloudFirst = By56Api.apiFileCloudFirst
// Vue.prototype.$apiBASIC = By56Api.apiBASIC
// Vue.prototype.$api05 = By56Api.api05
// Vue.prototype.$apiEn = By56Api.apiEn
// Vue.prototype.$apiCh = By56Api.apiCh
// Vue.prototype.$apiIMEn = By56Api.apiIMEn

// Object.keys(By56Api).forEach((v) => {
//   Vue.prototype['$' + v] = By56Api[v]
// })

import { post, fetch } from "@/ask/axios";
// 使用fetch API请求JSON文件
fetch("/static/env.json?t=" + new Date().getTime())
  .then(data => {
    // 处理获取的JSON数据
    console.log(data, "data"); // 打印或以其他方式使用数据
    let ApiMode = getBy56Api(data.env || process.env.METHOD || "dev");
    //同config.js里面的代码一起注释或放行
    //sysCfg.air = sysCfg.getAir(env || process.env.METHOD || 'dev');
    Object.keys(ApiMode).forEach(v => {
      Vue.prototype["$" + v] = ApiMode[v];
    });
    //isShowIeTips  判断ie  6 7 8 9,时不进入主内容
    if (!isShowIeTips) {
      new Vue({
        el: "#app",
        router,
        store,
        components: { App },
        template: "<App/>"
      });
    }
  })
  .catch(error => {
    // 处理错误情况
    console.error("There has been a problem with your fetch operation:", error);
  });



/*==============根据域名判断所调接口================*/



// WEBPACK FOOTER //
// ./src/main.js